import { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";




const Footer = () => {
  const { t } = useTranslation();

  const links = [
    { to: "/", label: t("footer.home") },
    { to: "/contact", label: t("footer.contact") },
    { to: "/privacy", label: t("footer.privacy") },
  ];

  return (
    <footer className="bg-bone border-t border-foreground/15" role="contentinfo">
      <div className="container mx-auto px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <Link
              to="/"
              className="inline-block hover:opacity-80 transition-opacity duration-200"
              aria-label={t("nav.homeAria")}
            >
              <img
                src="/assets/oceannova-horizontal-logo.png"
                alt="OceanNova"
                className="h-12 w-auto"
                width="200"
                height="48"
                loading="lazy"
              />
            </Link>
          </div>


          <div className="md:col-span-6 md:flex md:justify-end">
            <nav className="w-full md:w-auto md:min-w-56 border-t border-foreground/15 md:border-t-0">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="block border-b border-foreground/10 py-3 text-sm font-bold uppercase tracking-[0.12em] text-foreground/80 hover:text-cobalt transition-colors duration-200"
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground/15">
          <p className="text-xs uppercase tracking-[0.14em] text-muted-foreground">
            &copy; {new Date().getFullYear()} OceanNova. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
